import { render, staticRenderFns } from "./SocialMediaPostsTab.vue?vue&type=template&id=76e876ea"
import script from "./SocialMediaPostsTab.vue?vue&type=script&lang=js"
export * from "./SocialMediaPostsTab.vue?vue&type=script&lang=js"
import style0 from "./asset-split.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports